"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeCycles = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Copyright (c) 2017 Trent Mick.
 * Copyright (c) 2017 Joyent Inc.
 *
 * The bunyan logging library for node.js.
 * https://github.com/trentm/node-bunyan/blob/master/lib/bunyan.js
 *
 * -*- mode: js -*-
 * vim: expandtab:ts=4:sw=4
 */

// A JSON stringifier that handles cycles safely - tracks seen values in a Set.
function safeCyclesSet() {
  var seen = new Set();
  return function (key, val) {
    if (!val || _typeof(val) !== 'object') {
      return val;
    }
    if (seen.has(val)) {
      return '[Circular]';
    }
    seen.add(val);
    return val;
  };
}

/**
 * A JSON stringifier that handles cycles safely - tracks seen vals in an Array.
 *
 * Note: This approach has performance problems when dealing with large objects,
 * see trentm/node-bunyan#445, but since this is the only option for node 0.10
 * and earlier (as Set was introduced in Node 0.12), it's used as a fallback
 * when Set is not available.
 */
function safeCyclesArray() {
  var seen = [];
  return function (key, val) {
    if (!val || _typeof(val) !== 'object') {
      return val;
    }
    if (seen.indexOf(val) !== -1) {
      return '[Circular]';
    }
    seen.push(val);
    return val;
  };
}

/**
 * A JSON stringifier that handles cycles safely.
 *
 * Usage: JSON.stringify(obj, safeCycles())
 *
 * Choose the best safe cycle function from what is available - see
 * trentm/node-bunyan#445.
 */
var safeCycles = exports.safeCycles = typeof Set !== 'undefined' ? safeCyclesSet : safeCyclesArray;